<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
      <v-row no-gutters fill-height>
        <v-col cols="12" sm="12" lg="12" class="pa-0">
          <i-card-top class="d-md-flex"
            :useBtnList="[
              'btnSearch', 
            ]"
            @btnSearch="search(false)"
          >
            <template v-slot:body>
              <v-row dense align="center">
                <!-- <v-col cols="2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true }"
                    color="primary"
                    class="rounded-0 mt-1"
                    v-model="sysSelect"
                    :label="$t('System No')"
                    :items="sysList"
                    item-text="codeName"
                    item-value="code"
                    dense
                    outlined
                  />
                </v-col> -->
                <v-col cols="2" class="mt-1">
                  <v-text-field
                    v-model="ename"
                    :label="$t('E Name')"
                    dense 
                    outlined 
                    hide-details="auto"
                    clearable 
                  />
                </v-col>
                <v-col cols="2" class="mt-1">
                  <v-text-field
                    v-model="routerId"
                    :label="$t('Router Id')"
                    dense 
                    outlined 
                    hide-details="auto"
                    clearable 
                  />
                </v-col>
                <v-col cols="2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true }"
                    color="primary"
                    class="rounded-0 mt-1"
                    v-model="useSelect"
                    :label="$t('Use Y/N')"
                    :items="useList"
                    item-text="codeName"
                    item-value="code"
                    dense
                    outlined
                    clearable
                  />
                </v-col>
              </v-row>
            </template>
          </i-card-top>
        </v-col>
        <v-col cols="12" sm="12" lg="12" class="pa-2 pl-0 pb-0">
          <i-card-vertical headerTitle=""
                :useBtnList="[
                  'btnAdd', 
                  'btnSave',
                ]"
                style="height: 100%;"
                @btnAdd="btnAdd()"
                @btnSave="btnSave()"
              >
            <template v-slot:body>            
              <v-layout column >
                  <!-- Grid Main -->
                  <DxDataGrid
                    id="menuManage"
                    class="listBox"
                    :ref="dxDataGridRef"
                    :data-source="gridData"
                    key-expr="id"
                    :width="grid.width"
                    :show-borders="true"
                    :allow-column-resizing="true"
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true"
                    :column-hiding-enabled="false"
                    :hover-state-enabled="true"
                    :show-row-lines="true"
                    :remote-operations="false"
                    :focused-row-enabled="true"
                    @selection-changed="onSelectionChanged"
                    >
                    <DxPaging :enabled="false" :page-size="30"/>
                    <DxKeyboardNavigation
                      :edit-on-key-press="true"
                      enter-key-action="startEdit"
                      enter-key-direction="row"
                    />
                    <DxEditing
                      :allow-updating="true"
                      :allow-deleting="false"
                      :allow-adding="true"
                      :select-text-on-edit-start="true"
                      start-edit-action="dblClick"
                      mode="cell"
                    />
                    <DxScrolling column-rendering-mode="virtual"/>
                    <DxColumn data-field="systemNo" :caption="$t('System No')" width="auto" alignment="center" :allow-editing="false">
                      <DxLookup
                          :data-source="sysList"
                          display-expr="codeName"
                          value-expr="code"
                        />
                    </DxColumn>
                    <DxColumn data-field="menuId" :caption="$t('Menu ID')" width="auto" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="ename" :caption="$t('E Name')" width="auto" data-type="string" alignment="left" />
                    <DxColumn data-field="vname" :caption="$t('V Name')" width="auto" data-type="string" alignment="left" />
                    <DxColumn data-field="prtId" :caption="$t('Parent Menu ID')" width="auto" data-type="string" alignment="center" />
                    <!-- <DxColumn data-field="jspId" :caption="$t('JSP ID')" width="auto" data-type="string" alignment="left" /> -->
                    <DxColumn data-field="routerId" :caption="$t('Router Id')" width="auto" data-type="string" alignment="center" />
                    <!-- <DxColumn data-field="tabID" :caption="$t('Tab ID')" width="auto" data-type="string" alignment="center" />
                    <DxColumn data-field="levl" :caption="$t('Levl')" width="auto" data-type="string" alignment="center" />
                    <DxColumn data-field="imgNm" :caption="$t('Img Nm')" width="auto" data-type="string" alignment="center" /> -->
                    <DxColumn data-field="useYn" :caption="$t('Use YN')" width="auto" data-type="boolean" alignment="center" edit-cell-template="checkBoxEditor" />
                    <template #checkBoxEditor="{ data: cellInfo }">
                      <!-- <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" /> -->
                      <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
                    </template>
                    <DxColumn data-field="srt" :caption="$t('Srt')" width="auto" data-type="string" alignment="center" />
                    <!-- <DxColumn data-field="autDiv" :caption="$t('Aut Div')" width="auto" data-type="string" alignment="center" />
                    <DxColumn data-field="autDesc" :caption="$t('Aut Desc')" width="auto" data-type="string" alignment="center" /> -->
                    <DxColumn data-field="rgstDte" :caption="$t('Rgst Dte')" width="auto" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="rgstEmp" :caption="$t('Rgst Emp')" width="auto" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="revDte" :caption="$t('Rev Dte')" width="auto" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="revEmp" :caption="$t('Rev Emp')" width="auto" data-type="string" alignment="center" :allow-editing="false" />
                    <DxSelection
                      select-all-mode="allPages"
                      :show-check-boxes-mode="checkBoxesMode"
                      mode="multiple"
                    />
                  </DxDataGrid>
              </v-layout>
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
    import iCardVertical from '@/components/common/iCardVertical.vue'
    import { DxDataGrid, DxKeyboardNavigation, DxColumn, DxLookup, DxScrolling, DxEditing, DxSelection } from 'devextreme-vue/data-grid'
    import themes from 'devextreme/ui/themes'

    import notify from 'devextreme/ui/notify' // message

    import baseview from '@/components/base/baseview.vue' // base page 추가
    import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
 
    import { getAllMenu, createMenu} from '@/api/system/menuManage'
    import { getCmChildCode } from '@/api/system/cmCodeManage'
    import { getUserId, getComCode } from '@/utils/token'
    export default {
      name: 'menuManage',
      mixins: [baseview, BaseDataGrid], // base page 추가 및 권한 처리
      components: {
        'i-card-vertical': iCardVertical,
        DxDataGrid,
        DxKeyboardNavigation,
        DxColumn,
        DxLookup,
        DxScrolling,
        DxEditing,
        DxSelection
      },
      data() {
        return {
          dxDataGridRef: 'menuManage',
          gridData: [],
          useList: [],
          useSelect: 'Y',
          sysList: [],
          sysSelect: null,
          ename: '',
          routerId: '',
          checkBoxesMode: 'always' // themes.current().startsWith('material') ? 'always' : 'onClick',
        }
      },
      computed: {
        gridMainInstance() {
          return this.GetDataGrid(this.dxDataGridRef)
        }
      },
      mounted() {
        this.initForm()
      },
      methods: {
        async initForm() {
          await this.getSytemList()
          await this.getUseYNList()
          await this.search(true)
        },
        async getSytemList() {
          const params = {
            code: '',
            codegr: '',
            prtCode: 'GR_CODE',
            userFlag: 'Y'
          }

          await getCmChildCode(params).then(res => {
            // console.log('res', res)
            this.sysList = res.list
            this.sysSelect = 'HIP'
          })
        },
        async getUseYNList() {
          const params = {
            code: '',
            codegr: '',
            prtCode: 'USE_YN',
            userFlag: 'Y'
          }

          await getCmChildCode(params).then(res => {
            console.log('use list res', res)
            this.useList = res.list
          })
        },
        async search(event) {
          this.gridData = []
          this.openLoading('searching')
          this.gridMainInstance.clearSelection()
          // console.log('this.sysSelect', this.sysSelect)
          let params = {
            sysCd: this.sysSelect ? this.sysSelect : '',
            ename: this.ename ? this.ename : '',
            routerId: this.routerId ? this.routerId : '',
            useYn: this.useSelect ? this.useSelect : ''
          }
          console.log('params', params)
          await getAllMenu(params).then(res => {
            // console.log("RES : " , res)
            if(res.list) {
              this.gridData = res.list
            }
            // console.log('this.gridData', this.gridData)
            
            // if(event) {
            //   this.sysList = res.list.filter((v, i) => res.list.findIndex(x => x.sysType === v.sysType) === i).map(v => v.sysType)
            //   this.moduleList = res.list.filter((v, i) => res.list.findIndex(x => x.moduleCode === v.menuCode) === i).map(v => v.moduleCode)
            // }
            
            // console.log("moduleList : " , this.moduleList)
          }).finally(() => {
            this.endLoading()
          })
        },
        onSelectionChanged({ selectedRowsData }) {
          // console.log('onSelectionChanged : ',selectedRowsData)
        },
        column_customizeText(cellInfo) {
          return cellInfo.value//this.$t(cellInfo.value)
        },
        btnAdd() {
          let newRow = {
            id: (this.gridData.length + 1) + '',
            systemNo: this.sysSelect,
            menuId: '',
            ename: '',
            vname: '',
            prtId: '',
            jspId: '',
            routerId: '',
            tabId: '',
            levl: '',
            imgNm: '',
            useYn: 'Y',
            srt: '',
            autDiv: '',
            autDesc: '',
            __modified__: false,
            __created__: true
          }
          this.gridMainInstance.newRow(newRow)
          this.gridMainInstance.selectRows(newRow.id, true)
          this.gridMainInstance.option('focusedRowIndex', -1)
          this.gridMainInstance.option('focusedRowKey', this.gridMainInstance.option('dataSource').length)
        },
        async btnSave() {
          await this.gridMainInstance.saveEditData()
          let selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
          if (!selectedMainRows.length) {
            this.vToastify(this.$t('SelectCheck'), 'warn')
            return
          }

          for (let row of selectedMainRows) {
            if (row.__created__ !== true) {
              row.__modified__ = true
            }

            Object.keys(row).forEach(key => {
              if(key !== '__created__' && key !== '__modified__') {
                row[key] = row[key] ? row[key] : ''
              }
            })

            row.userId = this.$store.state.user.userId
          }
          // console.log('selectedMainRows : ',selectedMainRows)
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            current => {
              this.openLoading()
              this.gridMainInstance.beginUpdate() 
              let message = ''
              createMenu(selectedMainRows, true)
                .then(res => {
                  this.search(true)
                  message = selectedMainRows[0].__created__ == true ? 'Saved' :  'changed'
                  notify(this.$t(message), 'success', 3000)
                })
                .catch(error => {
                  // console.log("error : " , error)
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.gridMainInstance.endUpdate()
                  this.endLoading()
                })
            },
            null,
            true
          )
        },
      }
    }
  </script>